import { useEffect, useRef, useState } from 'react';

import useResizeObserver from '@/hooks/useResizeObserver';

import styles from './styles.module.css';

type Props = {
  isOpen: boolean;
  children: React.ReactNode;
};

const Collapse = ({ isOpen, children }: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!isOpen) {
      setHeight(0);
      return;
    }

    const element = contentRef.current;
    if (!element) return;

    setHeight(element.scrollHeight);
  }, [isOpen]);

  useResizeObserver(
    contentRef,
    () => {
      if (contentRef.current) setHeight(contentRef.current.scrollHeight);
    },
    isOpen
  );

  return (
    <div className={styles.collapse} aria-hidden={!isOpen} style={{ height }}>
      <div ref={contentRef}>{children}</div>
    </div>
  );
};

export default Collapse;
